import { loadStripe, Stripe } from '@stripe/stripe-js';
import { env, isContentfulDevelop, isDevelopment } from 'logic/env/envs';
import { forkJoin, from, Observable } from 'rxjs';

export const stripeConfig = {
  stripePromise: loadStripe(
    isDevelopment() || isContentfulDevelop() ? env.GATSBY_STRIPE_PK_DEV : env.GATSBY_STRIPE_PK_PROD
  ),
};

export const ofWithStripe: <T>() => (source: Observable<T>) => Observable<[T, Stripe]> = () => (
  source
) => {
  return forkJoin([source, from(stripeConfig.stripePromise as PromiseLike<Stripe>)]);
};
